/*
Author: Nishant Singh
*/

import { Cart } from '~api/cart';
import { createAsyncThunk } from '@reduxjs/toolkit';
import AsyncStorage from '~global/storage';

// ...........Actions creator
export const SET_VOUCHER = 'SET_VOUCHER';
export const RESET_VOUCHER = 'RESET_VOUCHER';
export const SET_SELECT_VOUCHER = 'SET_SELECT_VOUCHER';
export const SET_AUTO_APPLY_VOUCHER = 'SET_AUTO_APPLY_VOUCHER';
export const RESET_VOUCHER_DETAIL = 'RESET_VOUCHER_DETAIL';
export const SET_SELECT_PAYMENT_PROMO = 'SET_SELECT_PAYMENT_PROMO';
export const SET_BANK_PROMO = 'SET_BANK_PROMO';
export const RESET_BANK_PROMO = 'RESET_BANK_PROMO';
export const REQUEST_VOUCER_LIST = 'RESET_VOUCER_LIST';

// ..........actions
export const applyVoucher = createAsyncThunk(
  SET_VOUCHER,
  async (payload, thunkAPI) => {
    const cartDetail = thunkAPI.getState().cart.cartDetail;
    const UNSELECTED_PRODUCTS_KEY = 'unselected_products_cache';

    try {
      if (cartDetail?.unselected_products?.length > 0) {
        try {
          const existingData = await AsyncStorage.getItem(
            UNSELECTED_PRODUCTS_KEY,
          );
          const existingUnselectedProducts = existingData
            ? JSON.parse(existingData)
            : {};

          const cartId = cartDetail._id || 'default_cart';

          existingUnselectedProducts[cartId] = cartDetail.unselected_products;

          await AsyncStorage.setItem(
            UNSELECTED_PRODUCTS_KEY,
            JSON.stringify(existingUnselectedProducts),
          );
        } catch (storageError) {
          console.error('Error storing unselected products:', storageError);
        }
      }

      const res = await Cart.applyVoucherRequest(payload);
      if (res.status === 200) {
        return res.data.data;
      }
    } catch (err) {
      return err?.response?.data;
    }
  },
);

export const cancelVoucher = createAsyncThunk(
  RESET_VOUCHER,
  async (payload) => {
    try {
      const res = await Cart.cancelVoucherRequest(payload);
      if (res.status === 200) {
        return res.data.success;
      }
    } catch (err) {
      return err.response.data;
    }
  },
);
export const getVouchers = createAsyncThunk(
  REQUEST_VOUCER_LIST,
  async (payload) => {
    try {
      const res = await Cart.vouchersRequest(payload);
      if (res.status === 200) {
        return res.data.data;
      }
    } catch (err) {
      return err.response.data;
    }
  },
);

export const getVouchersCount = (params) => {
  return async () => {
    try {
      const res = await Cart.vouchersCountRequest(params);
      if (res.status === 200) {
        return res.data.data;
      }
    } catch (err) {
      return err.response.data;
    }
  };
};

export const getCategoryVouchers = createAsyncThunk(
  'cart/categoryVouchers',
  async (id) => {
    try {
      const res = await Cart.getVouchersByCategoryIdRequest(id, {
        fields:
          '_id name discount_type free_products_type voucher_info image to_date code',
        sort: '-created_at',
      });
      return res.data.data;
    } catch (err) {
      return err.response.data;
    }
  },
);

export const setSelectVoucher = (payload) => {
  return async (dispatch) => {
    dispatch({ type: SET_SELECT_VOUCHER, payload });
  };
};

export const setAutoApplyVoucher = (payload) => {
  return async (dispatch) => {
    dispatch({ type: SET_AUTO_APPLY_VOUCHER, payload });
  };
};

export const resetVoucherDetail = (payload) => {
  return async (dispatch) => {
    dispatch({ type: RESET_VOUCHER_DETAIL, payload });
  };
};

export const applyRedeemBankPromo = createAsyncThunk(
  SET_BANK_PROMO,
  async (payload) => {
    try {
      const res = await Cart.applyBankPromoRequest(payload);
      if (res.status === 200) {
        return res.data.data;
      }
    } catch (err) {
      return err.response.data;
    }
  },
);

export const cancelRedeemBankPromo = createAsyncThunk(
  RESET_BANK_PROMO,
  async (payload) => {
    try {
      const res = await Cart.cancelBankPromoRequest(payload);
      if (res.status === 200) {
        return res.data.success;
      }
    } catch (err) {
      console.error(err.message);
    }
  },
);
